import React, { useRef, useEffect, useCallback, useState } from "react";

function useStickToBottom(threshold = 20) {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isAtBottom, setIsAtBottom] = useState(true);

  const scrollToBottom = useCallback(() => {
    const el = scrollRef.current;
    if (el) {
      el.scrollTop = el.scrollHeight;
    }
  }, []);

  const handleScroll = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return;
    const diff = el.scrollHeight - el.scrollTop - el.clientHeight;
    setIsAtBottom(diff < threshold);
  }, [threshold]);

  useEffect(() => {
    if (isAtBottom) {
      scrollToBottom();
    }
  });

  return { scrollRef, isAtBottom, scrollToBottom, handleScroll };
}


export {useStickToBottom};